// extracted by mini-css-extract-plugin
export var tag = "heroTags-module--tag--32b09";
export var wrap = "heroTags-module--wrap--5f575";